import React from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import { DataEntry } from './types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const LedgerGroup = styled.span`
  font-size: 12px;
`;

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 6px solid ${colors.copper};
  margin: 4px 12px;
`;

type DataEntriesProps = {
  data: Array<DataEntry>;
  compressed: boolean;
};

const findLedgers = (dataEntries: Array<DataEntry>, entryType: string): Array<DataEntry> =>
  dataEntries.filter(entry => entry.entryType === entryType);

export const getFromLedgers = (dataEntries: Array<DataEntry>) => findLedgers(dataEntries, 'CREDIT');
export const getToLedgers = (dataEntries: Array<DataEntry>) => findLedgers(dataEntries, 'DEBIT');

const DataEntries = ({ data, compressed }: DataEntriesProps) => {
  const fromLedgers = getFromLedgers(data);
  const toLedgers = getToLedgers(data);

  return (
    <Wrapper>
      {fromLedgers.map(({ ledgerAccountId, ledgerName }, index) => (
        <LedgerGroup key={ledgerAccountId}>
          {index > 0 && ', '}
          {compressed && index > 0 ? '...' : ledgerName}
        </LedgerGroup>
      ))}
      <Triangle />
      {toLedgers.map(({ ledgerAccountId, ledgerName }, index) => (
        <LedgerGroup key={ledgerAccountId}>
          {index > 0 && ', '}
          {compressed && index > 0 ? '...' : ledgerName}
        </LedgerGroup>
      ))}
    </Wrapper>
  );
};

DataEntries.defaultProps = {
  compressed: true,
};

export default DataEntries;
